export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/selection/empty.js
// module id = J06R
// module chunks = 0